// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"02a28178","455":"e9baeee5","977":"ddfe4342"}[chunkId] + ".chunk.js";
};